/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "personalwebsite",
            "endpoint": "https://0cilyth1be.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "cities-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "personalInfo-dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
